import { Button, styled } from '@material-ui/core';

const ButtonSearch = styled(Button)({
  padding: '12px 50px',
  //marginLeft: '20px',
});

export default ButtonSearch;
